import type { UserSecurityControl } from '../types';

export const UserSecurityControlApi = Symbol.for('UserSecurityControlApi');

/**
 * 用户安全控制 API
 */
export interface UserSecurityControlApi {
    /**
     * 获取当前用户安全控制配置
     */
    getAmountsControl(): Promise<UserSecurityControl>;
}
